module.exports = __webpack_public_path__ + "img/syszl.51d95973.png";